import React from 'react';
import { PAGE_MODE } from '../../../constants/constants';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import { BasePage } from "../../../framework/pages/BasePage";
import { UserUtil } from '../../../util/UserUtil'; 
import { getModePlanProcedimientoDetail } from './getModePlanProcedimientoDetail';

export class PlanProcedimientoDetailPage extends BasePage {
    createPageProperties = (pageApi) => {
        return {
            title: 'Plan Procedimiento',
            mode: getModePlanProcedimientoDetail
        };
    }
    renderPage(pageApi) {
        const getForm = () => pageApi.getComponent('form');

        const formConfig = { 
            load: {
                queryId: 908,
                params: { id_plan: pageApi.getParamId() }
            },
            save: {
                queryId: 906,
                params: {id_user: UserUtil.getUserId()},
                postLink: (resp, values) => '/plan-procedimiento/plan-procedimiento-admin'
            },
            update: {
                queryId: 907,
                params: {id_user: UserUtil.getUserId()},
                postLink: (resp, values) => '/plan-procedimiento/plan-procedimiento-admin'
            },
            fields: [
                { name: 'desc_plan', label: 'Plan Procedimiento', column: 6}, 
                {
                type: "select",
                name: "id_tipo_cadena",
                label: "Matriz",
                column: 4,
                load: { queryId: 905 },
                search: true,
                },  
            ],
            onComponentLoad: (formApi, pageApi) => {
                if (pageApi.getPageMode() !== PAGE_MODE.NEW)
                    formApi.load();
            }
        };


        const barButtonconfig = {
            fields: [
                { ...BUTTON_DEFAULT.RETURN, link: '/plan-procedimiento/plan-procedimiento-admin' },
                { ...BUTTON_DEFAULT.SAVE, onClick: () => getForm().save() },
                { ...BUTTON_DEFAULT.UPDATE, onClick: () => getForm().update() },
            ]
        }

        return (
            <>
                <FormFw
                    name="form"
                    getParentApi={pageApi.getApi}
                    config={formConfig}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
            </>
        )

    }
}